"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcAbstractSwipeBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var common_constants_1 = require("../../../common/constants/common-constants");
var bc_abstract_swipe_constants_1 = require("./bc-abstract-swipe-constants");
var bc_abstract_swipe_constants_2 = require("./bc-abstract-swipe-constants");
var bc_abstract_swipe_constants_3 = require("./bc-abstract-swipe-constants");
var bc_abstract_swipe_constants_4 = require("./bc-abstract-swipe-constants");
function round(n, p) {
    if (p === void 0) { p = 0; }
    var p = (p === 0) ? bc_abstract_swipe_constants_2.SWIPE_NUMBER_100 : Math.pow(bc_abstract_swipe_constants_3.SWIPE_NUMBER_10, p);
    return Math.round(n * p) / p;
}
function clamp(number, lower, upper) {
    return Math.min(Math.max(number, lower), upper);
}
var BcAbstractSwipeBehavior = (function (_super) {
    __extends(BcAbstractSwipeBehavior, _super);
    function BcAbstractSwipeBehavior() {
        var _this = _super.call(this) || this;
        _this.current = 0;
        _this.vWidth = 0;
        _this.mWidth = 0;
        _this.target = 0;
        _this.timeSettingCss = bc_abstract_swipe_constants_3.SWIPE_NUMBER_500;
        _this.curDown = false;
        _this.rAF = null;
        _this.initialized = false;
        _this.numListeners = 0;
        _this.listeners = [];
        _this.lastOffset = 0;
        _this.finalPositionSlider = bc_abstract_swipe_constants_4.SWIPE_NUMBER_50;
        _this.positionTranslateYX = 0;
        _this.startX = 0;
        _this.startY = 0;
        _this.calc = function (event) {
            _this.target += event.X;
            _this.clampTarget();
            if (_this.rAF === null) {
                requestAnimationFrame(_this.moveSlider);
            }
        };
        _this.moveSlider = function () {
            var offset = (_this.target - _this.current);
            _this.current += offset * bc_abstract_swipe_constants_1.SWIPE_EASE;
            var currentRound = round(_this.current);
            _this.setCSS(currentRound);
            if (parseInt(offset.toFixed(bc_abstract_swipe_constants_4.SWIPE_NUMBER_2)) == 0) {
                _this.rAF = null;
                if (_this.config.infinity) {
                    _this.restoreSwipe(offset);
                }
                else {
                    _this.pivots(offset, currentRound);
                }
            }
            else {
                _this.rAF = requestAnimationFrame(_this.moveSlider);
            }
            _this.config.onMoving && _this.config.onMoving(currentRound);
        };
        _this.pivots = function (offset, xValue) {
            var bounce = function (starting, to) {
                _this.setCSS(starting + to);
                setTimeout(function () {
                    _this.setCSS(starting);
                }, _this.timeSettingCss);
            };
            if (_this.isLastClamp(offset)) {
                bounce(xValue, -_this.finalPositionSlider);
            }
            if (_this.isStartClamp()) {
                bounce(xValue, _this.finalPositionSlider);
            }
        };
        _this.restoreSwipe = function (offset) {
            if (_this.isLastClamp(offset)) {
                _this.moveSliderTo(0);
            }
            if (_this.isStartClamp()) {
                _this.moveSliderTo(_this.mWidth * -1);
            }
        };
        _this.isStartClamp = function () { return (_this.swipeToLeft && _this.target == bc_abstract_swipe_constants_1.SWIPE_CERO); };
        _this.onResize = function () {
            var parentWidth = _this.mySelf.getBoundingClientRect().width;
            var contentWidth = _this.containerItems.getBoundingClientRect().width;
            _this.vWidth = window.innerWidth;
            _this.mWidth = contentWidth + (_this.vWidth - parentWidth);
            _this.clampTarget();
            _this.rAF = requestAnimationFrame(_this.moveSlider);
        };
        _this.on = function (f) {
            if (!_this.initialized) {
                _this.addListeners();
            }
            _this.listeners.push(f);
            _this.numListeners = _this.listeners.length;
        };
        _this.notify = function (e) {
            var _e = (_this.isTouch && e.targetTouches) ? e.targetTouches[0] : e;
            _this.swipeEvent.X = (_e.pageX - _this.swipeEvent.initialX) * _this.config.speed;
            _this.swipeEvent.Y = (_e.pageY - _this.swipeEvent.initialY) * _this.config.speed;
            _this.swipeEvent.originalEvent = e;
            _this.swipeEvent.cursorDown = _this.curDown;
            _this.swipeEvent.initialX = _e.pageX;
            _this.swipeEvent.initialY = _e.pageY;
            for (var i = 0; i < _this.numListeners; i++) {
                _this.listeners[i](_this.swipeEvent);
            }
        };
        _this.onDrag = function (e) {
            if (_this.curDown) {
                e.preventDefault();
                if (e.type == 'mousemove') {
                    _this.setDirection(e.screenX);
                    _this.deltaPosition(e);
                }
            }
        };
        _this.onDragStart = function (e) {
            var _e = (_this.isTouch && e.targetTouches) ? e.targetTouches[0] : e;
            _this.swipeEvent.initialX = _e.pageX;
            _this.swipeEvent.initialY = _e.pageY;
            _this.curDown = true;
            _this.setDirection(_e.screenX);
            _this.startX = _e.pageX;
            _this.startY = _e.pageY;
            _this.deltaPosition(e);
        };
        _this.onDragEnd = function (e) {
            _this.curDown = false;
        };
        _this.onMouseLeave = function (e) {
            _this.onDragEnd(e);
        };
        _this.addListeners = function () {
            if (_this.hasMouseEvent) {
                _this.mySelf.addEventListener('mouseleave', _this.onMouseLeave);
                _this.mySelf.addEventListener('mouseup', _this.onDragEnd);
                _this.mySelf.addEventListener('mousedown', _this.onDragStart);
                _this.mySelf.addEventListener('mousemove', _this.onDrag);
            }
            if (_this.hasTouchEvent) {
                _this.mySelf.addEventListener('touchmove', _this.onDrag);
                _this.mySelf.addEventListener('touchend', _this.onDragEnd);
                _this.mySelf.addEventListener('touchstart', _this.onDragStart);
            }
        };
        _this.removeListeners = function () {
            if (_this.hasMouseEvent) {
                _this.mySelf.removeEventListener('mouseleave', _this.onMouseLeave);
                _this.mySelf.removeEventListener('mouseup', _this.onDragEnd);
                _this.mySelf.removeEventListener('mousedown', _this.onDragStart);
                _this.mySelf.removeEventListener('mousemove', _this.onDrag);
            }
            if (_this.hasTouchEvent) {
                _this.mySelf.removeEventListener('touchmove', _this.onDrag);
                _this.mySelf.removeEventListener('touchend', _this.onDragEnd);
                _this.mySelf.removeEventListener('touchstart', _this.onDragStart);
            }
        };
        _this.deltaPosition = function (event) {
            var touch = event instanceof TouchEvent && event.changedTouches ? event.changedTouches[0] : event;
            _this.deltaX = touch.pageX - _this.startX;
            _this.deltaY = touch.pageY - _this.startY;
            if ((Math.abs(_this.deltaX) > Math.abs(_this.deltaY)) && _this.deltaX !== 0) {
                _this.notify(event);
            }
        };
        return _this;
    }
    BcAbstractSwipeBehavior.prototype._setUp = function () {
        this.initConfiguration();
        this.getElements();
        this.init();
    };
    BcAbstractSwipeBehavior.prototype.init = function () {
        var _this = this;
        this.swipeInit();
        this.on(function (e) { return _this.calc(e); });
        this.mySelf.addEventListener(common_constants_1.BcCommonConstants.EVENT_RESIZE, this.onResize);
        this.onResize();
    };
    BcAbstractSwipeBehavior.prototype.setConfig = function (config) {
        this.config = config;
        this.initConfiguration();
    };
    BcAbstractSwipeBehavior.prototype.initConfiguration = function () {
        this.config = __assign({ speed: bc_abstract_swipe_constants_2.SWIPE_MIN_SPEED, contentItemsClass: bc_abstract_swipe_constants_1.SWIPE_CLASS, sliderClass: bc_abstract_swipe_constants_2.SLIDER_CLASS, step: bc_abstract_swipe_constants_1.SLIDER_STEP, infinity: false }, (this.config || {}));
    };
    BcAbstractSwipeBehavior.prototype.getElements = function () {
        var contentItemsClass = this.mySelf.querySelector(".".concat(this.config.contentItemsClass));
        if (!contentItemsClass) {
            throw bc_abstract_swipe_constants_1.SWIPE_NOT_CONTENT_CLASS_ELEMENTS;
        }
        this.containerItems = contentItemsClass;
    };
    BcAbstractSwipeBehavior.prototype.swipeInitConfig = function () {
        this.swipeEvent = {
            X: bc_abstract_swipe_constants_1.SWIPE_CERO,
            Y: bc_abstract_swipe_constants_1.SWIPE_CERO,
            cursorDown: false,
            initialX: bc_abstract_swipe_constants_1.SWIPE_CERO,
            initialY: bc_abstract_swipe_constants_1.SWIPE_CERO,
            originalEvent: null
        };
        this.initialized = false;
        this.curDown = false;
        this.numListeners = bc_abstract_swipe_constants_1.SWIPE_CERO;
        this.listeners = [];
    };
    BcAbstractSwipeBehavior.prototype.setDirection = function (lastOffset) {
        this.swipeToLeft = lastOffset > this.lastOffset;
        this.lastOffset = lastOffset;
    };
    BcAbstractSwipeBehavior.prototype.moveSliderToLeft = function (toLeft) {
        this.target = toLeft ? this.target + this.config.step : this.target - this.config.step;
        this.clampTarget();
        this.moveSlider();
    };
    BcAbstractSwipeBehavior.prototype.moveSliderTo = function (value) {
        this.target = value;
        this.clampTarget();
        this.moveSlider();
    };
    BcAbstractSwipeBehavior.prototype.setCSS = function (position) {
        var x = "".concat(Math.ceil(position), "px");
        this.containerItems.style.transform = "translate3d(".concat(x, ",").concat(this.positionTranslateYX, ",").concat(this.positionTranslateYX, ")");
    };
    BcAbstractSwipeBehavior.prototype.isLastClamp = function (moveTo) {
        return (!this.swipeToLeft && this.target < bc_abstract_swipe_constants_1.SWIPE_CERO && this.target == this.current && moveTo == bc_abstract_swipe_constants_1.SWIPE_CERO);
    };
    BcAbstractSwipeBehavior.prototype.clampTarget = function () {
        var max = this.mWidth - this.vWidth;
        this.target = clamp(this.target, -1 * max, 0);
    };
    BcAbstractSwipeBehavior.prototype.detectInterationType = function () {
        this.hasMouseEvent = 'onmousedown' in document;
        this.hasTouchEvent = 'ontouchstart' in document;
        var supportsMultitouch = navigator.maxTouchPoints && navigator.maxTouchPoints > 1;
        this.isTouch = this.hasTouchEvent || supportsMultitouch;
    };
    BcAbstractSwipeBehavior.prototype.swipeInit = function () {
        this.swipeInitConfig();
        this.detectInterationType();
    };
    return BcAbstractSwipeBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcAbstractSwipeBehavior = BcAbstractSwipeBehavior;
